module.exports = __webpack_public_path__ + "static/img/kids_4.5b6b6f61.png";